module.exports = __webpack_public_path__ + "static/media/Step2.dc4e91d6.png";